import React, { useMemo } from 'react';
import classnames from 'classnames';
import styles from './index.module.css';
import { UberHealthTag } from '../../UberHealthTag/UberHealthTag';
import { LodashHelper } from '../../../../utils';
import { useCurrentRole } from '../../../../hooks/useCurrentRole';
import { vehicleOptionsDictionary } from '../../../../dictionaries';

export const UberReceiptInfo = ({
  receipt,
  seqId,
  uberInfo,
  rideId,
  vehicleType,
  userRole,
  rideReceipt,
  uberReceiptData
}) => {
  const { isMHAdmin } = useCurrentRole(userRole);
  console.log('uberReceiptData', uberReceiptData);
  console.log('rideReceipt', rideReceipt);
  console.log('receipt', receipt);
  // const customerTotalSource = hoTotalAmount ?? totalAmountRaw;
  // const customerTotalRideChargesAmount = displayAmount(customerTotalSource);
  // const showCustomerTotalRideCharges =
  //   hasDisplayValue(totalAmountRaw) ||
  //   hasDisplayValue(hoMarkupAmount) ||
  //   hasDisplayValue(hoTotalAmount);

  // const customerAmountDue = customerTotalRideChargesAmount;

  const c = uberInfo?.cancellationInfo;
  const cancellationDetailsBlock =
    c &&
      (c.driver_wait_time_minutes != null ||
        c.cancellation_type ||
        c.cancellation_time_stamp != null ||
        c.driver_arrived_time_stamp != null) ? (
      <div style={{ margin: '12px 0 0 0' }}>
        <p className={styles.rideReceiptLabel} style={{ marginBottom: '6px' }}>
          Uber cancellation (from trip record)
        </p>
        {c.cancellation_type != null && (
          <p style={{ margin: '0 0 4px 0' }}>
            Type: {String(c.cancellation_type).replace(/_/g, ' ')}
          </p>
        )}
        {c.driver_wait_time_minutes != null && (
          <p style={{ margin: '0 0 4px 0' }}>Driver wait: {c.driver_wait_time_minutes} min</p>
        )}
        {c.driver_arrived_time_stamp != null && (
          <p style={{ margin: '0 0 4px 0', fontSize: 12 }}>
            Driver arrived: {new Date(Number(c.driver_arrived_time_stamp)).toLocaleString()}
          </p>
        )}
        {c.cancellation_time_stamp != null && (
          <p style={{ margin: 0, fontSize: 12 }}>
            Canceled: {new Date(Number(c.cancellation_time_stamp)).toLocaleString()}
          </p>
        )}
      </div>
    ) : null;

  return (
    <div className={styles.receiptsContainer}>
      {rideReceipt && (
        <div className={`${styles.rideReceiptContainer} ${styles.customerReceiptCard}`}>
          <div className={styles.rideReceiptHeader} style={{ marginBottom: '16px', alignItems: 'center' }}>
            <div className={classnames(styles.flexWithColumnDir)} style={{ flex: 1 }}>
              <h2 style={{ margin: 0 }}>Customer Receipt</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UberHealthTag />
            </div>
          </div>

          <div className={styles.rideReceiptHeader} style={{ marginBottom: 0 }}>
            <div className={classnames(styles.flexWithColumnDir)} style={{ flex: 1 }}>
              <p className={styles.rideReceiptLabel}>Receipt #</p>
              {<p style={{ margin: 0 }}>{rideReceipt?.receiptId}</p>}
            </div>

            <div className={classnames(styles.flexWithColumnDir)} style={{ alignItems: 'flex-end' }}>
              <p className={styles.rideReceiptLabel}>Ride ID</p>
              <p style={{ margin: 0 }}>{seqId}</p>
            </div>
          </div>

          <div style={{ margin: '12px 0 0 0' }}>
            <p className={styles.rideReceiptLabel} style={{ marginBottom: '2px' }}>Type</p>
            <p style={{ margin: 0 }}>{vehicleOptionsDictionary.uberAmbulatoryRide}</p>
          </div>

          {/* {cancellationDetailsBlock} */}

          <p className={styles.rideReceiptDescTitle} style={{ margin: '16px 0 10px 0' }}>
            Description <span>Charges</span>
          </p>

          {(
            <div className={styles.rideReceiptHeader} style={{ marginBottom: '6px' }}>
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0 }}>Total Ride Charges (including taxes &amp; fees)</p>
              </div>

              <div style={{ textAlign: 'right', minWidth: '70px' }}>
                <p style={{ margin: 0 }}>{"$" + (Number(rideReceipt?.totalAmount) || 0).toFixed(2)}</p>
              </div>
            </div>
          )}

          <hr className={styles.rideReceiptDivider} style={{ margin: '12px 0 16px 0' }} />

          <p className={styles.billTotal} style={{ margin: 0 }}>
            Amount Due
            <span className={styles.billTotalValue}>{"$" + (Number(rideReceipt?.totalAmount) || 0).toFixed(2)}</span>
          </p>
        </div>
      )}

      {isMHAdmin && uberReceiptData && (
        <div className={`${styles.rideReceiptContainer} ${styles.uberReceiptCard}`} style={{ marginTop: '10px' }}>

          <div className={styles.rideReceiptHeader} style={{ marginBottom: '16px', alignItems: 'center' }}>
            <div className={classnames(styles.flexWithColumnDir)} style={{ flex: 1 }}>
              <h2 style={{ margin: 0 }}>Uber Receipt</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UberHealthTag />
            </div>
          </div>

          <div className={styles.rideReceiptHeader} style={{ marginBottom: 0 }}>
            <div className={classnames(styles.flexWithColumnDir)} style={{ flex: 1 }}>
              <p className={styles.rideReceiptLabel}>Receipt #</p>
              {<p style={{ margin: 0 }}>{receipt?.receiptId}</p>}
            </div>
            <div className={classnames(styles.flexWithColumnDir)} style={{ alignItems: 'flex-end' }}>
              <p className={styles.rideReceiptLabel}>Ride ID</p>
              <p style={{ margin: 0 }}>{seqId}</p>
            </div>
          </div>

          <div style={{ margin: '12px 0 0 0' }}>
            <p className={styles.rideReceiptLabel} style={{ marginBottom: '2px' }}>Type</p>
            <p style={{ margin: 0 }}>{vehicleOptionsDictionary.uberAmbulatoryRide}</p>
          </div>

          {/* {cancellationDetailsBlock} */}

          <p className={styles.rideReceiptDescTitle} style={{ margin: '16px 0 10px 0' }}>
            Description <span>Charges</span>
          </p>

          {uberReceiptData?.charge_adjustments?.map((row) => (
            <div
              className={styles.rideReceiptHeader}
              style={{ marginBottom: '6px' }}
              key={row.key}
            >
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0 }}>{row.name}</p>
              </div>
              <div style={{ textAlign: 'right', minWidth: '70px' }}>
                <p style={{ margin: 0 }}>{"$" + (Number(row.amount) || 0).toFixed(2)}</p>
              </div>
            </div>
          ))}
          {uberReceiptData?.charges?.map((row) => (
            <div
              className={styles.rideReceiptHeader}
              style={{ marginBottom: '6px' }}
              key={row.key}
            >
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0 }}>{row.name}</p>
              </div>
              <div style={{ textAlign: 'right', minWidth: '70px' }}>
                <p style={{ margin: 0 }}>{"$" + (Number(row.amount) || 0).toFixed(2)}</p>
              </div>
            </div>
          ))}

          <hr className={styles.rideReceiptDivider} style={{ margin: '12px 0 16px 0' }} />

          <p className={styles.billTotal} style={{ margin: 0 }}>
            Amount Due
            <span className={styles.billTotalValue}>
              {receipt?.totalAmount > 0 ? ("$" + (Number(receipt?.totalAmount) || 0).toFixed(2)) :
                uberReceiptData?.total_fare}</span>
          </p>
        </div>
      )}

    </div>

  );
};
